import { render, staticRenderFns } from "./notifyTips.vue?vue&type=template&id=6e37c616&"
import script from "./notifyTips.vue?vue&type=script&lang=js&"
export * from "./notifyTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e37c616')) {
      api.createRecord('6e37c616', component.options)
    } else {
      api.reload('6e37c616', component.options)
    }
    module.hot.accept("./notifyTips.vue?vue&type=template&id=6e37c616&", function () {
      api.rerender('6e37c616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ui-document/components/notifyTips.vue"
export default component.exports